import { render, staticRenderFns } from "./BillHistoryModal.vue?vue&type=template&id=527c2744"
import script from "./BillHistoryModal.vue?vue&type=script&lang=js"
export * from "./BillHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports